import agentImage from 'images/default-avatar.png';
import {
  fontSemiBold,
  textLg,
  textLgLineHeight,
  fontBold,
} from './styleConstants';

export default function AgentMessage({ xMargins = {} }) {
  return (
    <>
      <p
        style={{
          fontSize: textLg,
          lineHeight: textLgLineHeight,
          fontWeight: fontSemiBold,
          ...xMargins,
        }}
      >
        Dear Mr Williams,
      </p>
      <p
        style={{
          marginBottom: '1rem',
          marginTop: '1rem',
          ...xMargins,
        }}
      >
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque
        maximus erat vitae velit dictum dapibus. Cras massa leo, pharetra id
        sagittis ut, gravida a nunc. Integer vitae sapien at enim porta cursus
        et ut enim. Nulla facilisis bibendum quam vitae accumsan. Sed ac cursus
        sem, et porta orci. Donec tincidunt interdum felis at ornare. Curabitur
        sed pharetra lacus, nec venenatis nulla. Nunc ac semper lectus.
      </p>
      <p style={{ marginBottom: '1rem', marginTop: '1rem', ...xMargins }}>
        Pellentesque efficitur maximus pellentesque. Vestibulum suscipit auctor
        eros, et fringilla erat euismod suscipit. Mauris blandit quis tortor non
        rutrum. Quisque tellus mauris, volutpat non euismod id, ultrices eget
        erat. Suspendisse venenatis arcu vel velit gravida, sed venenatis enim
        hendrerit. Donec auctor velit ex, non cursus urna consequat at. Sed
        maximus aliquet lacus et hendrerit.
      </p>
      <p style={{ marginBottom: '1rem', marginTop: '1rem', ...xMargins }}>
        Kind regards,
      </p>
      <p style={{ marginBottom: '1rem', marginTop: '1rem', ...xMargins }}>
        Jordan
      </p>
      <div style={{ borderBottomWidth: '1px', ...xMargins }}>
        <div
          style={{
            display: 'flex',
            gap: '1rem',
            paddingTop: '2rem',
            paddingBottom: '2rem',
          }}
        >
          <img
            style={{ borderRadius: '9999px', height: '4rem' }}
            src={agentImage}
            alt="agent"
          />
          <div>
            <div
              className="flex gap-4 font-bold pb-4"
              style={{
                display: 'flex',
                gap: '1rem',
                fontWeight: fontBold,
                paddingBottom: '1rem',
              }}
            >
              <p>Jordan Lambert</p>
              <p>Travel Specialist</p>
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sem
              augue, dictum id pharetra quis, elementum quis enim. Nulla id
              lacinia sem, malesuada feugiat eros. Fusce nec turpis commodo,
              vehicula lorem rutrum, dictum neque. Fusce imperdiet libero nunc,
              ac cursus ex aliquam at. Mauris vel finibus est. Phasellus
              elementum scelerisque ultricies.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
